import React from "react";
import Popover from "../PopOver";
import Icon from "../Icon";

import "../PopOver/style.css";
import styles from "./Tooltip.module.scss";

const Tooltip = ({
  children = null,
  placement = "right",
  recordHistory = false
}) => {
  const [isVisible, setVisible] = React.useState(false);
  return (
    <Popover
      caret
      placement={placement}
      setVisible={setVisible}
      spacing={4}
      target={
        <Icon
          className={recordHistory ? styles.recordHistoryHelpIcon : styles.icon}
          type="info_filled"
        />
      }
      valign="top"
      visible={isVisible}
    >
      {children}
    </Popover>
  );
};

export default Tooltip;
